
import { useConfigStore } from "@/store/config";
import { defineComponent } from "vue";

export default defineComponent({
  props: {
    plan: {
      type: Object,
      required: true
    }
  },
  setup() {
    const plansMap = useConfigStore().plansMap;
    function formatPrice(planCode: string) {
      let price = plansMap.get(planCode)?.unitAmount;
      return price ? `${(price / 100).toFixed(2)}` : null;
    }
    return { formatPrice };
  }
});
